import Icon from 'src/components/atoms/icon'
import ConfigIcon from 'src/assets/icons/ui/config.svg?react'
import UserMenuNew from 'src/components/molecules/user-menu-new'
import NotificationIcon from 'src/assets/icons/ui/nofity.svg?react'

import { Layout } from 'antd'
import { Button, Flex } from 'antd'
import { useRouter } from 'src/hooks'
import { useGoBackStore } from 'src/stores'
import { useTranslation } from 'react-i18next'

function Header() {
  const router = useRouter()

  const { i18n } = useTranslation()
  const { goBackState } = useGoBackStore()

  return (
    <Layout.Header className="flex z-[2001] h-14 items-center justify-between border-b border-gray-100 bg-bg-base px-4">
      {goBackState ? (
        <Button icon={<Icon name="ArrowLeft" />} onClick={router.goBack}>
          {i18n.t('action.back')}
        </Button>
      ) : (
        <span />
      )}

      <Flex gap="small" align="center">
        <Button icon={<NotificationIcon />} data-testid="notification-btn" />
        <Button icon={<ConfigIcon />} data-testid="settings-btn" />
        <UserMenuNew />
      </Flex>
    </Layout.Header>
  )
}

export default Header
